import { handleUpdateProcessWorkflow } from 'serviceWorker/services/processes';
import { processSource } from 'serviceWorker/services/processes/processSource';
import { channelServer, ChannelUnsubscribe } from 'shared/channels';
import { processContract } from 'shared/domain/process/processContract';
import { serveEntityRequests } from './serveEntityRequests';

/** Answers the process requests: the list, and workflow changes answered once queued. */
export function serveProcessRequests(): ChannelUnsubscribe {
  const unsubscribes = [
    serveEntityRequests(processContract, processSource),
    channelServer.handle(processContract, { updateWorkflow: handleUpdateProcessWorkflow }),
  ];
  return () => unsubscribes.forEach((unsubscribe) => unsubscribe());
}
